import { render } from "./routeCreate.vue?vue&type=template&id=a06b639c&scoped=true"
import script from "./routeCreate.vue?vue&type=script&lang=js"
export * from "./routeCreate.vue?vue&type=script&lang=js"

import "./routeCreate.vue?vue&type=style&index=0&id=a06b639c&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06b639c"]])

export default __exports__